import { ProductDescription } from '../exposure/style'
import {
  ProductsPromoContainer,
  SmartProductItem,
  SmartProductsList,
  SmartSecureProducts,
  SmartSecureProductsTitle,
} from './style'

import { Image } from 'components'
import { getProductDetails } from './service'
import { useStore } from 'services/store'

export const SmartProducts: React.FC = () => {
  const { isDarkMode } = useStore()
  const productItems = getProductDetails(isDarkMode)

  return (
    <SmartSecureProducts>
      <SmartSecureProductsTitle>Smart, secure products</SmartSecureProductsTitle>
      <SmartProductsList>
        {productItems.map((item, index) => (
          <SmartProductItem key={index}>
            <ProductsPromoContainer>
              <Image src={item.image} />
            </ProductsPromoContainer>
            <ProductDescription>{item.description}</ProductDescription>
          </SmartProductItem>
        ))}
      </SmartProductsList>
    </SmartSecureProducts>
  )
}

export default SmartProducts
